function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-youtube",
  "data-name": "Icon awesome-youtube",
  d: "M40.214,8.725a4.928,4.928,0,0,0-3.536-3.417C33.558,4.5,21.05,4.5,21.05,4.5s-12.508,0-15.628.808A4.928,4.928,0,0,0,1.886,8.725c-.836,3.014-.836,9.3-.836,9.3s0,6.289.836,9.3a4.859,4.859,0,0,0,3.536,3.362c3.119.808,15.628.808,15.628.808s12.508,0,15.628-.808a4.859,4.859,0,0,0,3.536-3.362c.836-3.014.836-9.3.836-9.3s0-6.289-.836-9.3ZM16.959,23.737V12.318l10.455,5.71L16.959,23.737Z",
  transform: "translate(-1.05 -4.5)",
  fill: "#596375"
});

var SvgIconAwesomeYoutube = function SvgIconAwesomeYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 27,
    viewBox: "0 0 40 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAwesomeYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-awesome-youtube.293600ac.svg";
export { ForwardRef as ReactComponent };